module.exports = __webpack_public_path__ + "img/veteran-friendly.1da04ab4.png";